import { alpha, darken } from '@mui/material/styles';

export function buildTablePalette({ mode, brandMain, palette, darkElevated }) {
  return {
    headerGradientStart: mode === 'dark' ? darken(brandMain, 0.2) : brandMain,
    headerGradientEnd: mode === 'dark' ? brandMain : darken(brandMain, 0.15),
    headerStripeEven: alpha(palette.text.primary, mode === 'dark' ? 0.25 : 0.08),
    headerColumnOverlay: mode === 'dark'
      ? `linear-gradient(180deg, ${alpha(palette.common.white, 0.08)}, ${alpha(palette.common.black, 0.2)})`
      : `linear-gradient(180deg, ${alpha(palette.common.white, 0.35)}, ${alpha(palette.common.black, 0.05)})`,
    headerSeparator: mode === 'dark'
      ? alpha(palette.common.black, 0.35)
      : alpha(palette.common.black, 0.1),
    headerText: palette.getContrastText(brandMain),
    rowBgOdd: mode === 'dark' ? darkElevated : 'var(--row-odd)',
    rowBgEven: mode === 'dark' ? alpha(darkElevated, 0.9) : 'var(--row-even)',
    rowTextOdd: palette.text.primary,
    rowTextEven: palette.text.primary,
    hoverRowBg: mode === 'dark' ? alpha(palette.common.white, 0.04) : 'var(--row-hover)',
    hoverRowText: palette.text.primary,
    selectedRowBg: alpha(brandMain, mode === 'dark' ? 0.35 : 0.18),
    selectedRowText: palette.getContrastText(brandMain),
    containerBg: palette.background.paper,
    border: palette.divider,
    shadow: 'var(--shadow-soft)',
    loaderText: palette.text.secondary,
    emptyBg: palette.background.default,
    emptyText: palette.text.secondary,
  };
}
